import { useSearchParams } from 'react-router-dom';

const PopupError = () => {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  if (error && window.opener) {
    window.opener.postMessage({ type: 'message', error }, window.origin);

    // Set up listener for ACK
    const ackHandler = (event: MessageEvent) => {
      if (event.origin !== window.origin) return;

      if (event.data.type === 'ACK') {
        window.removeEventListener('message', ackHandler);
        window.close();
      }
    };

    window.addEventListener('message', ackHandler);

    // Fallback timeout in case ACK never comes
    setTimeout(() => {
      window.removeEventListener('message', ackHandler);
      window.close();
    }, 5000); // 5 second timeout
  }

  return null;
};

export default PopupError;
